module.exports = __webpack_public_path__ + "static/media/renbo1.94e4adea.webp";